import fr from './fr.json' with { type: 'json' };
import en from './en.json' with { type: 'json' };

export const resources = {
  fr: { translation: fr },
  en: { translation: en },
} as const;

export type TranslationKeys = keyof typeof fr;

export * from './site/index.js';
